<template>
  <div class="wrapper">
    <div class="tilte-text"> 推广订单 </div>
    <div class="search-wrap" style="margin-top: 20px;">
      <template>
        <span class="search-label">订单状态</span>
        <Select v-model="searchForm.status" style="width:150px" placeholder="全部状态">
          <Option v-for="item in statusList" :value="item.value" :key="item.value">{{ item.label }}</Option>
        </Select>
      </template>
      <template>
        <span class="search-label">会员昵称</span>
        <Input v-model="searchForm.nickName" placeholder="会员昵称" style="width: 150px;" />
      </template>
      <!--<template>-->
        <!--<Input v-model="searchForm.phone" placeholder="会员手机" style="width: 150px;" />-->
      <!--</template>-->
      <template>
        <span class="search-label">订单编号</span>
        <Input v-model="searchForm.orderNumber" placeholder="订单编号" style="width: 150px;" />
      </template>
      <br>
      <template>
        <span class="search-label">佣金值</span>
        <Input v-model="searchForm.commissionMix" placeholder="最小佣金值" style="width: 150px;" />
        <span class="search-rang-label">至</span>
        <Input v-model="searchForm.commissionMax" placeholder="最大佣金值" style="width: 150px;" />
      </template>
      <template>
        <span class="search-label">下单日期</span>
        <DatePicker type="date" placeholder="开始时间" v-model="searchForm.start_time_bak" style="width: 150px;"></DatePicker>
        <span class="search-rang-label">至</span>
        <DatePicker type="date" placeholder="结束时间" v-model="searchForm.end_time_bak"></DatePicker>
      </template>
      <template>
        <Button type="text" class="search-btn margin-left-30" @click="handleFilter">查询</Button>
        <Button type="text" class="search-btn"  @click="handleOrderExport">订单导出</Button>
        <!-- <Button type="text" style="border: 1px solid #D63036; color: #D63036;">下载报表</Button> -->
      </template>
    </div>
    <div class="table-wrapper">
      <Table border
             :columns="columns"
             :data="list"
             :loading="listLoading">
      <template slot-scope="{ row }" slot="action">
        <span class="color-ff4" style="cursor: pointer" @click="showDetail(row)">查看详情</span>
      </template>
      </Table>
      <div style="padding: 10px 0px">
        <Page :total="total"
              :current="searchForm.pageNo"
              show-sizer
              show-elevator
              show-total
              @on-change="changePage"
              @on-page-size-change="changePagesize"
              ></Page>
      </div>
    </div>
    <detail ref='detail'></detail>
  </div>
</template>
<script>
  import { getPlatformUuidKfc, getToken,  getUserUUID} from '@/utils/auth'
  import { Icon, Table, Page, Button, Select, Option, Input, DatePicker } from 'view-design'
  //import { getOrderList } from '@/api/order'
  import { numFormatter } from '@/utils/date'
  import Detail from '@/components/kfc/TicketDetail.vue'
  import { getDate } from '@/utils/date'
  import order from '@/javaApi/kfc/order'
  const orderModel = new order()
  export default {
    name: 'Order',
    components: {
      Icon,
      Table,
      Page,
      Button,
      Select,
      Option,
      Input,
      DatePicker,
      Detail
    },
    data: function () {
      return {
        columns: [
          {
            title: '套餐信息',
            key: 'goods_info',
            fixed: 'left',
            width: 250,
            render: (h, params) => {
              let name = params.row.name
              let imageUrl = params.row.imageUrl

              let renderData = []
              if(imageUrl) {
                renderData.push(
                  h('img',{
                    attrs:{
                      src: imageUrl, style: 'width: 30%;height: auto;margin:15px;float:left;cursor:pointer;'
                    },
                  })
                )
              }
              renderData.push(
                h('span', {
                  attrs: {
                    style:'display: block;cursor: pointer;margin-top: 15px;color:#1287EA;'
                  }
                }, name)
              )
              return h('div',
                {
                  attrs: {
                    style: 'display: flex; align-items: center;'
                  },
                  on: {
                    click: () => {
                      this.showDetail(params.row)
                    }
                  }
                }, renderData);
            }
          },
          {
            title: '订单编号',
            key: 'orderNumber',
            width: 280,
            align: 'center',
          },
          {
            title: '下单会员',
            key: 'nickName',
            width: 120,
            align: 'center'
          },
          {
            title: '下单时间',
            key: 'createTime',
            width: 120,
            align: 'center',
          },
          {
            title: '支付金额',
            key: 'payPrice',
            width: 120,
            align: 'center',
          },
          {
            title: '订单总佣金',
            key: 'commission',
            width: 120,
            align: 'center',
          },
          {
            title: '订单状态',
            key: 'statusStr',
            width: 110,
            align: 'center'
          },
          {
            title: '结算时间',
            key: 'settleTime',
            width: 130,
            align: 'center',
            render: (h, params) => {
              let renderData = []
              const settleTime = [20,40].includes(params.row.status) ? '取餐后48小时' : params.row.settleTime
              renderData.push(settleTime);
              return renderData
            }
          },
          {
            title: '操作',
            key: 'action',
            width: 100,
            slot: 'action',
            align: 'center',
          },
        ],
        listLoading: false,
        list:[],
        statusList: [
          {"label":"全部","value":""},
          {"label":"未支付","value":"2"},
          {"label":"已支付","value":"10"},
          {"label":"进行中","value":"20"},
          {"label":"退款中","value":"30"},
          {"label":"已完成","value":"40"},
          {"label":"已退款","value":"50"}
        ],
        total:0,
        platformUuid: getPlatformUuidKfc() || '',
        searchForm: {
          pageNo: 1,
          pageSize: 10,
          status: undefined,
          phone: undefined,
          nickName: undefined,
          orderNumber: undefined,
          userId: undefined,
          commissionMix: undefined,
          commissionMax: undefined,
          start_time_bak: undefined,
          end_time_bak: undefined,
          createStartTime: undefined,
          createEndTime: undefined,
          platformUuid: undefined,
        }
      }
    },
    created() {
      let param = this.$route.query
      if(param.user_id){
        this.searchForm.userId = param.user_id
      }
      if(param.nick_name){
          this.searchForm.nickName = param.nick_name
      }
      this.getList(true)
    },
    methods: {
      getList(first = false){
        if(first) this.searchForm.pageNo = 1
        let searchForm = Object.assign({}, this.searchForm)
        // 如果查询的参数为空直接unset 掉
        searchForm = this.formateInit(searchForm)
        let condition = (this.platformUuid == '' || this.platformUuid == 0);
        if(!condition){
          searchForm.platformUuid =  this.platformUuid
        } else {
          return false;
        }
        let createTimeStartStr = getDate(searchForm.start_time_bak)
        if(createTimeStartStr){
          searchForm.createStartTime = createTimeStartStr+' 00:00:00'
        }else{
          delete  searchForm.createStartTime
        }
        let createTimeEndStr = getDate(searchForm.end_time_bak)
        if(createTimeEndStr){
          searchForm.createEndTime = createTimeEndStr+' 23:59:59'
        }else{
          delete  searchForm.createEndTime
        }

        delete searchForm.start_time_bak
        delete searchForm.end_time_bak
        this.listLoading = true
        if(searchForm.userId){
          searchForm.userId = numFormatter(searchForm.userId)
        }
        orderModel.getOrderList(searchForm).then((response) => {
          var res = response.data
          this.listLoading = false
          if(res.code != 200){
            this.$Message.error(res.message)
            return
          }
          this.list = res.data.list
          this.total = res.data.total
        })
      },
      formateData(data){
        if(!data){
          return []
        }
        if(!data.length){
          return []
        }
        let i = 0;
        let pageNo = this.searchForm.pageNo
        let pageSize = this.searchForm.pageSize
        for(i=0;i<data.length;i++){
          data[i].sequence = (i+1)+(pageNo - 1)*pageSize
        }
        return  data
      },
      formateInit(formData){
        let objCopy = {};
        for(let key in formData){
          if(formData[key]){
            objCopy[key] = formData[key];
          }
        }
        return objCopy;
      },
      handleFilter(){
        this.getList(true)
      },
      //订单导出
      handleOrderExport() {
        this.listLoading = true
        let searchForm = Object.assign({}, this.searchForm)
        // 如果查询的参数为空直接unset 掉
        searchForm = this.formateInit(searchForm)
        let condition = (this.platformUuid == '' || this.platformUuid == 0);
        if(!condition){
          searchForm.platformUuid =  this.platformUuid
        }
        let createTimeStartStr = getDate(searchForm.start_time_bak)
        if(createTimeStartStr){
          searchForm.createStartTime = createTimeStartStr+' 00:00:00'
        }else{
          delete  searchForm.createStartTime
        }
        let createTimeEndStr = getDate(searchForm.end_time_bak)
        if(createTimeEndStr){
          searchForm.createEndTime = createTimeEndStr+' 23:59:59'
        }else{
          delete  searchForm.createEndTime
        }

        delete searchForm.start_time_bak
        delete searchForm.end_time_bak
        delete searchForm.pageNo
        delete searchForm.pageSize

        searchForm.xToken = getToken()
        searchForm.uuid = getUserUUID()
        searchForm = this.formateInit(searchForm)
        orderModel.exportOrder(searchForm).then(async (res) => {
          this.listLoading = false
          const message = res.data.info || res.data.message
          await this.$alert(`${message}`, '提示', {
            showCancelButton: true,
            confirmButtonText: '前往导出列表',
            cancelButtonText: '取消',
            callback: action => {
              if(action === 'confirm'){
                this.$router.push({ path: "/pc/exportCenter/index" });
              }
              this.exportLoading = false
            }
          });
        })
      },
      formatDate(date) {
        var y = date.getFullYear();
        var m = date.getMonth() + 1;
        m = m < 10 ? '0' + m : m;
        var d = date.getDate();
        d = d < 10 ? ('0' + d) : d;
        return y + m + d;
      },
      changePage(value){
        this.searchForm.pageNo = value
        this.getList()
      },
      changePagesize(value){
        this.searchForm.pageSize = value;
        //如果处于第一页改变数量，则会触发changePage
        if(this.searchForm.pageNo == 1){
          this.getList()
        }
      },
      showDetail (row) {
        this.$refs.detail.init(row)
      },
      // 佣金详情
      showCommissionDetail (row) {
        this.$refs.commissionDetail.init(row)
      },
    }
  }
</script>
<style scoped>
  .wrapper {
    width: 100%;
    font-size: 12px;
  }
  .wrapper .tilte-text {
    font-size: 18px;
    color: #222222;
    text-align: left;
    font-weight: bold;
  }
  .wrapper .table-wrapper {
    margin-top: 30px;
  }
  .search-wrap .ivu-icon-ios-arrow-down:before{
    color: #232323;
    content: "\F33D";
  }
  .ivu-date-picker-rel {
    margin: 11px 0;
  }
  .ivu-table{
    background: #FFFFFF;
    border: 1px solid #EEEEEE;
    border-radius: 2px;
  }
  .table-wrapper .ivu-table-header th {
    background-color: #FCFAF8 !important;
  }
  .table-wrapper .ivu-table-header th .ivu-table-cell{
    color: #222222 !important;
  }
  .table-wrapper .ivu-table-wrapper-with-border{
    border: none;
  }
  .table-wrapper .ivu-table-wrapper-with-border{
    border-radius: 0px;
    border-color: #FFFFFF !important;
  }
  .ivu-table td.color-blue .ivu-table-cell{
    color: #3A94F2;
  }
</style>



// WEBPACK FOOTER //
// src/views/pc/kfc/order/Index.vue